<template>
  <div class="list-wrap">
    <div class="peak">
      <img src="@/assets/images/top.png" alt="" />
      <h4 class="title">会员中心</h4>
    </div>
    <!-- 固定顶部个人信息 -->
    <div
      class="header"
      :class="{ active: selectHead }"
      @click="selectModule('header')"
      ref="header"
    >
      <div
        class="cardWrap"
        :style="{
          backgroundImage:
            'url(' + pageConfig.menberPage.currentImage.src + ')',
        }"
      >
        <div
          class="info"
          :style="{
            backgroundImage:
              'url(' + pageConfig.menberPage.currentCrad.card + ')',
          }"
        >
          <div class="top">
            <div
              class="shopName"
              :style="{ backgroundColor: pageConfig.menberPage.bgColor + '4D' }"
            >
              <!-- <img src="@/assets/images/icon_shop.svg" alt=""> -->
              <i
                class="iconfont"
                :style="{ color: pageConfig.menberPage.color }"
                >&#xe6a5;</i
              >
              <span :style="{ color: pageConfig.menberPage.color }"
                >{{ this.$store.getters.loginUserInfo.shopTitle }}</span
              >
            </div>
            <img class="score" src="@/assets/images/icon_VIP5.png" alt="" />
          </div>
          <div class="bottom">
            <div class="avar">
              <img src="@/assets/images/avar.jpg" alt="" />
            </div>
            <div class="details">
              <span class="name" :style="{ color: pageConfig.menberPage.color }"
                >小云儿</span
              >
              <span class="int" :style="{ color: pageConfig.menberPage.color }"
                >2563积分</span
              >
            </div>
          </div>
        </div>
      </div>
      <!-- 控制条 -->
      <div class="controlBarWrap" v-show="controlState">
        <ul class="controlList">
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe68f;</i>
          </li>
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe691;</i>
          </li>
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe690;</i>
          </li>
          <li class="control" style="color: #ccc">
            <i class="iconfont">&#xe692;</i>
          </li>
        </ul>
      </div>
    </div>
    <!-- 中间列表 -->
    <transition-group name="flip-list" tag="ul" ref="list" class="list">
      <!-- li中的key属性需对应数据中的排序 -->
      <li
        v-for="(data, index) in pageConfig.menberPage.pageComponents"
        :key="'component' + data.id + index"
        :data-id="data.id"
        :class="{ active: data.select }"
      >
        <!-- 会员权益 -->
        <div
          class="powerWrap"
          :class="{ active: data.select, mrb10: !data.hideGaps }"
          v-if="data.id == 1"
          @click="selectModule(data)"
          :key="'componen' + index"
        >
          <div class="moduleTitle">
            <h6 class="title">会员权益</h6>
            <span class="more"
              >查看更多 <i class="el-icon-arrow-right"></i
            ></span>
          </div>
          <div>
            <div class="powerList">
              <div
                class="power"
                v-for="(item, index) in pageConfig.menberPage.powerScoreList[
                  pageConfig.menberPage.selectPowerItem
                ]"
                :key="'powern' + index"
              >
                <img :src="item.imageUrl" alt="" />
                <span>{{ item.name }}</span>
              </div>
            </div>
            <!-- <div
              class="open"
              v-if="pageConfig.menberPage.selectPowerItem != spliceData"
              @click="aass = !aass"
            >
              下一等级会员权益 <i class="el-icon-arrow-up" v-if="aass"></i>
              <i class="el-icon-arrow-down" v-if="!aass"></i>
            </div>
            <div
              class="powerList"
              v-if="pageConfig.menberPage.selectPowerItem != spliceData && aass"
            >
              <div
                class="power"
                v-for="(item, index) in pageConfig.menberPage.powerScoreList[
                  pageConfig.menberPage.selectPowerItem + 1
                ]"
                :key="'powers' + index"
              >
                <img class="filter" :src="item.imageUrl" alt="" />
                <span class="default">{{ item.name }}</span>
              </div>
            </div> -->
          </div>
          <!-- 控制条 -->
          <div class="controlBarWrap" v-show="data.select">
            <ul class="controlList">
              <li class="control" @click="handleControl('topping', data)">
                <i class="iconfont">&#xe68f;</i>
              </li>
              <li class="control" @click="handleControl('moveUp', data)">
                <i class="iconfont">&#xe691;</i>
              </li>
              <li class="control" @click="handleControl('moveDown', data)">
                <i class="iconfont">&#xe690;</i>
              </li>
              <li class="control" @click="handleControl('delete', data)">
                <i class="iconfont">&#xe692;</i>
              </li>
            </ul>
          </div>
        </div>
        <!-- 热门互动 -->
        <div
          class="hotWrap"
          :class="{ active: data.select, mrb10: !data.hideGaps }"
          v-if="data.id == 2"
          @click="selectModule(data)"
          :key="'componen' + index"
        >
          <div class="moduleTitle">
            <h6 class="title">热门互动</h6>
            <span class="more"
              >查看更多 <i class="el-icon-arrow-right"></i
            ></span>
          </div>
          <div class="hotList">
            <template v-for="(item, index) in pageConfig.menberPage.hotList">
              <div class="hot" :key="'hot' + index" v-if="item.visibility">
                <div
                  class="color"
                  :style="{
                    background:
                      'linear-gradient(132deg, ' +
                      item.color +
                      ' 0%, ' +
                      item.color +
                      '33 100%)',
                  }"
                ></div>
                <img :src="item.imageUrl" class="icons" alt="" />
                <div class="news">
                  <span class="name">{{ item.name || item.activityName }}</span>
                  <span class="desc">{{ item.desc }}</span>
                </div>
              </div>
            </template>
          </div>
          <!-- 控制条 -->
          <div class="controlBarWrap" v-show="data.select">
            <ul class="controlList">
              <li class="control" @click="handleControl('topping', data)">
                <i class="iconfont">&#xe68f;</i>
              </li>
              <li class="control" @click="handleControl('moveUp', data)">
                <i class="iconfont">&#xe691;</i>
              </li>
              <li class="control" @click="handleControl('moveDown', data)">
                <i class="iconfont">&#xe690;</i>
              </li>
              <li class="control" @click="handleControl('delete', data)">
                <i class="iconfont">&#xe692;</i>
              </li>
            </ul>
          </div>
        </div>
        <!-- 兑换精选 -->
        <div
          class="exchangeWrap"
          :class="{ active: data.select, mrb10: !data.hideGaps }"
          v-if="data.id == 3"
          @click="selectModule(data)"
          :key="'componen' + index"
        >
          <div class="moduleTitle">
            <h6 class="title">兑换精选</h6>
            <span class="more"
              >查看更多 <i class="el-icon-arrow-right"></i
            ></span>
          </div>
          <div class="exchangeList">
            <template
              v-for="(item, index) in pageConfig.menberPage.exchangeList"
            >
              <div
                class="goods"
                :key="'exchange' + index"
                v-if="item.visibility"
              >
                <img :src="item.imageUrl" class="good" alt="" />
                <div class="desc">
                  <p class="name">{{ item.name || item.activityName }}</p>
                  <p class="int">{{ item.int }}积分</p>
                </div>
                <div class="exchangeBtn">去兑换</div>
              </div>
            </template>
          </div>
          <!-- 控制条 -->
          <div class="controlBarWrap" v-show="data.select">
            <ul class="controlList">
              <li class="control" @click="handleControl('topping', data)">
                <i class="iconfont">&#xe68f;</i>
              </li>
              <li class="control" @click="handleControl('moveUp', data)">
                <i class="iconfont">&#xe691;</i>
              </li>
              <li class="control" @click="handleControl('moveDown', data)">
                <i class="iconfont">&#xe690;</i>
              </li>
              <li class="control" @click="handleControl('delete', data)">
                <i class="iconfont">&#xe692;</i>
              </li>
            </ul>
          </div>
        </div>
      </li>
    </transition-group>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import Sortable from "sortablejs";

export default {
  data() {
    return {
      // 是否选中头部
      selectHead: false,
      // 头部控制条
      controlState: false,
      aass: false,
      domList: [],
      spliceData: 0,
    };
  },
  computed: {
    ...mapState(["pageConfig", "pathNow"]),
  },
  mounted() {
    this.init();
    this.getLevel();
    console.log(this.pathNow,998);
  },
  methods: {
    ...mapMutations([
      "componentListChange",
      "switchConfigState",
      "addComponent",
      "delComponent",
      "toppingComponent",
      "upAndDown",
    ]),
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          this.spliceData = res.data.length;
        })
        .catch((res) => {});
    },

    init() {
      let self = this;
      let options = {
        animation: 500,
        dataIdAttr: "data-id",
        filter: ".filter",
        sort: false,
        group: { name: "list", pull: false, put: true },
        onAdd(evt) {
          const arr = sortList.toArray();
          self.componentListChange(+evt.oldIndex);
          self.addComponent(arr);
          self.domList.push({
            id: evt.clone.dataset.id,
            dom: evt.clone,
          });
          evt.clone.className = "wrap";
          evt.item.remove();
        },
        onEnd: function(evt) {},
      };
      var sortList = Sortable.create(this.$refs.list.$el, options);
     
      // let self = this;
      // let options = {
      //   animation: 500,
      //   dataIdAttr: "data-id",
      //   filter: ".filter",
      //   sort: false,
      //   // ghostClass: 'drawStyle',
      //   group: { name: "list", pull: false, put: true },
      //   onAdd(evt) {
      //     const arr = sortList.toArray();
      //     self.componentListChange(+evt.oldIndex);
      //     self.addComponent(arr);
      //     self.domList.push({
      //       id: evt.clone.dataset.id,
      //       dom: evt.clone,
      //     });
      //     // const newArr = [];
      //     // arr.forEach(id => {
      //     //     const obj = self.domList.find(item => item.id == id);
      //     //     if(obj) {
      //     //         newArr.push(obj);
      //     //     }
      //     // })
      //     // self.domList = newArr;
      //     evt.clone.className = "wrap";
      //     evt.item.remove();
      //   },
      //   onChange(evt) {
      //     // console.log(evt);
      //   },
      //   onEnd: function(evt) {},
      // };
      // var sortList = Sortable.create(this.$refs.list.$el, options);
    },
    selectModule(data) {
      if (data === "header") {
        if (this.selectHead) return;
        this.selectHead = true;
        this.controlState = true;
        this.pageConfig.menberPage.pageComponents.forEach(
          (item) => (item.select = false)
        );
        this.switchConfigState(0);
      } else {
        this.selectHead = false;
        this.controlState = false;
        if (data.select) return;
        this.pageConfig.menberPage.pageComponents.forEach(
          (item) => (item.select = false)
        );
        data.select = true;
        this.switchConfigState(data.id);
      }
    },
    handleControl(type, data) {
      switch (type) {
        case "topping":
          this.toppingComponent(data.id);
          break;
        case "moveUp":
          this.upAndDown({ id: data.id, type: "moveUp" });
          break;
        case "moveDown":
          this.upAndDown({ id: data.id, type: "moveDown" });
          break;
        case "delete":
          this.delComponent(data.id);
          const obj = this.domList.find((item) => item.id == data.id);
          this.domList = this.domList.filter((item) => item.id != data.id);
          // 将左侧组件恢复可拖拽状态
          if (obj) obj.dom.className = "wrap draw";
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.list-wrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  // height: calc(100% - 68px);
  .peak {
    position: relative;
    width: 100%;
    img {
      width: 100%;
    }
    .title {
      position: absolute;
      left: 50%;
      top: 60%;
      transform: translate(-50%);
      margin: 0;
      text-align: center;
      font-size: 20px;
      font-weight: 600;
      color: #333;
    }
  }
  .header {
    position: relative;
    flex-shrink: 0;
    box-sizing: border-box;
    width: 100%;
    height: 168px;
    background-color: #fff;
    &.active {
      border: 2px dashed #4878ff;
    }
    .cardWrap {
      box-sizing: border-box;
      padding: 16px 15px 0;
      height: 168px;
      transition: all 0.3s;
      .info {
        box-sizing: border-box;
        padding: 14px 18px 18px;
        height: 100%;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        background-size: 100%;
        background-repeat: no-repeat;
        transition: all 0.3s;
        .top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .shopName {
            box-sizing: border-box;
            display: flex;
            align-items: center;
            padding: 5px 16px;
            border-radius: 45px;
            background-color: RGBA(243, 220, 182, 0.9);
            transition: all 0.2s;
            img {
              width: 18px;
              height: 16px;
            }
            span {
              margin-left: 7px;
              color: #4d340c;
              font-size: 13px;
              transition: all 0.2s;
            }
          }
          .score {
            width: 55px;
            height: 19px;
          }
        }
        .bottom {
          display: flex;
          align-items: center;
          margin: 28px 0 0 25px;
          .avar {
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 58px;
              height: 58px;
              border-radius: 50%;
              border: 3px solid #fff;
            }
          }
          .details {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-left: 20px;
            .name {
              margin-bottom: 4px;
              font-size: 16px;
              font-weight: bold;
              color: #4d340c;
              transition: all 0.2s;
            }
            .int {
              color: #4d340c;
              font-size: 14px;
              font-weight: 500;
              transition: all 0.2s;
            }
          }
        }
      }
    }
  }
  .list {
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 0;
    li {
      position: relative;
      &.active {
        z-index: 9999;
      }
    }
    .moduleTitle {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;
      .title {
        color: #000;
        font-size: 17px;
        font-weight: bold;
      }
      .more {
        color: #aaa;
        font-size: 12px;
        font-weight: 500;
      }
    }
    .powerWrap {
      position: relative;
      box-sizing: border-box;
      background-color: #fff;
      width: 100%;
      padding: 16px;
      &.active {
        border: 2px dashed #4878ff;
      }
      .powerList {
        display: flex;
        flex-wrap: wrap;
        .power {
          width: 25%;
          text-align: center;
          transition: all 0.3s;
          &:nth-child(n + 5) {
            margin-top: 20px;
          }
          img {
            width: 50px;
            height: 50px;
          }
          span {
            display: block;
            margin-top: 6px;
            color: #000;
            font-size: 12px;
            font-weight: 500;
          }
          .default {
            color: #999;
          }
          .filter {
            filter: grayscale(1);
            opacity: 0.6;
          }
        }
      }
      .open {
        margin: 20px 0;
        color: #aaa;
        text-align: center;
        font-size: 13px;
        font-weight: 500;
        cursor: pointer;
      }
    }
    .hotWrap {
      position: relative;
      box-sizing: border-box;
      background-color: #fff;
      width: 100%;
      padding: 16px 16px 6px;
      &.active {
        border: 2px dashed #4878ff;
      }
      .hotList {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        height: 217px;
        overflow: hidden;
        .hot {
          display: flex;
          align-items: center;
          box-sizing: border-box;
          position: relative;
          padding: 16px;
          width: 48%;
          border-radius: 10px;
          margin-bottom: 12px;
          overflow: hidden;
          .color {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;

            opacity: 0.2;
          }
          .icons {
            width: 70px;
            margin-right: 16px;
          }
          .news {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            color: #000;
            font-size: 15px;
            font-weight: bold;
            .desc {
              margin-top: 4px;
              text-align: left;
              color: #999;
              font-size: 12px;
              font-weight: 400;
            }
          }
        }
      }
    }
    .exchangeWrap {
      position: relative;
      box-sizing: border-box;
      background-color: #fff;
      width: 100%;
      padding: 16px;
      &.active {
        border: 2px dashed #4878ff;
      }
      .exchangeList {
        display: flex;
        flex-wrap: wrap;
        height: 170px;
        overflow: hidden;
        .goods {
          flex: 1;
          box-sizing: border-box;
          padding: 12px 15px;
          // width: 31%;
          margin-right: 12px;
          margin-bottom: 12px;
          background-color: #fcfafa;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          &:last-child {
            margin: 0;
          }
          .good {
            height: 63px;
            margin-bottom: 10px;
          }
          .desc {
            margin-bottom: 8px;
            text-align: center;
            p {
              margin: 0;
            }
            .name {
              color: #000;
              font-size: 12px;
              font-weight: 500;
            }
            .int {
              margin-top: 4px;
              color: #999;
              font-size: 10px;
              font-weight: 400;
            }
          }
          .exchangeBtn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 78px;
            height: 25px;
            margin: 0 auto;
            text-align: center;
            background: linear-gradient(90deg, #ff8a4a 0%, #ff5e4d 100%);
            border-radius: 25px;
            color: #fff;
            font-size: 12px;
            font-weight: 500;
          }
        }
      }
    }
  }
}
</style>
